<template>
	<div class="registro-medio">
		<div class="registro-medio-main">
			<div class="container">
				<div class="registro-medio-left">
					<h1>Registro de medio</h1>
					<p>Complete el siguiente formulario para registrar su medio</p>
					<div class="registro-medio-content">
						<div class="medio-form">
							<div class="medio-form-row">
								<span class="title">Datos del medio</span>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="medio-nombre">Nombre del medio</label>
									<input type="text" name="medio-nombre" id="medio-nombre" v-model="medio.nombre">
								</div>
								<div class="input-group">
									<label for="medio-tipo">Tipo</label>
									<multiselect name="medio-tipo" id="medio-tipo" v-model="medio.tipo" :options="medioTipos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de medios disponibles.</span>
									</multiselect>
								</div>
							</div>
							<div class="medio-form-row">
								<span class="title">Redes sociales y sitio web <span class="title-subtitle">(en caso de tener)</span></span>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="medio-instagram">Instagram</label>
									<input type="text" name="medio-instagram" id="medio-instagram" v-model="medio.instagram">
								</div>
								<div class="input-group">
									<label for="medio-twitter">Twitter</label>
									<input type="text" name="medio-twitter" id="medio-twitter" v-model="medio.twitter">
								</div>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="medio-sitioWeb">Sitio web</label>
									<input type="text" name="medio-sitioWeb" id="medio-sitioWeb" v-model="medio.sitioWeb">
								</div>
							</div>
						</div>
						<div>
							<h2>Responsable del medio</h2>
							<p>Completa los datos de quién será el responsable del medio.</p>
						</div>
						<div class="medio-responsable-form">
							<div class="medio-form-row">
								<div class="input-group">
									<label for="responsable-nombre">Nombres</label>
									<input type="text" name="responsable-nombre" id="responsable-nombre" v-model="medioResponsable.nombre">
								</div>
								<div class="input-group">
									<label for="responsable-apellido">Apellidos</label>
									<input type="text" name="responsable-apellido" id="responsable-apellido" v-model="medioResponsable.apellido">
								</div>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="responsable-tipo-documento">Tipo de documento</label>
									<multiselect name="responsable-tipo-documento" id="responsable-tipo-documento" v-model="medioResponsable.tipoDocumento" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="input-group">
									<label for="responsable-documento">Documento</label>
									<input type="text" name="responsable-documento" id="responsable-documento" v-model="medioResponsable.documento" placeholder="Sin puntos ni guiones. Ej: 12345678">
								</div>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="responsable-email">Correo electrónico</label>
									<input type="email" name="responsable-email" id="responsable-email" v-model="medioResponsable.email">
								</div>
								<div class="input-group">
									<label for="responsable-telefono">Teléfono</label>
									<input type="telefono" name="responsable-telefono" id="responsable-telefono" v-model="medioResponsable.telefono" @keypress="soloNumeros">
								</div>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="responsable-aufid">AUF ID</label>
									<input type="file" id="responsable-aufid" ref="responsableaufid" name="responsable-aufid" accept=".png, .jpg, .jpeg" @change="onFileChange">
								</div>
								<div class="input-group">
									<span class="small-text">Debes adjuntar tu carnet AUF ID en un formato .png o .jpg, y en un tamaño no mayor a 2MB.</span>
								</div>
							</div>
						</div>
						<div>
							<h2>Integrantes del medio</h2>
							<p>Ingresa todos los integrantes del medio.</p>
							<span class="disclaimer"></span>
						</div>
						<div class="medio-integrantes-form" v-for="(integrante, index) in medioIntegrantes" :key="integrante.id">
							<div class="medio-form-row">
								<div class="input-group">
									<label for="integrante-nombre">Nombres</label>
									<input type="text" name="integrante-nombre" id="integrante-nombre" v-model="integrante.nombre">
								</div>
								<div class="input-group">
									<label for="integrante-apellido">Apellidos</label>
									<input type="text" name="integrante-apellido" id="integrante-apellido" v-model="integrante.apellido">
								</div>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="integrante-tipo-documento">Tipo de documento</label>
									<multiselect name="integrante-tipo-documento" id="integrante-tipo-documento" v-model="integrante.tipoDocumento" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="input-group">
									<label for="integrante-documento">Documento</label>
									<input type="text" name="integrante-documento" id="integrante-documento" v-model="integrante.documento" placeholder="Sin puntos ni guiones. Ej: 12345678">
								</div>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label :for="'integrante-aufid' + index">AUF ID</label>
									<input type="file" :id="'integrante-aufid' + index" :ref="'integranteaufid' + index" :name="'integrante-aufid' + index" accept=".png, .jpg, .jpeg" @change="onFileChangeIntegrante($event, index)">
								</div>
								<div class="input-group">
									<span class="small-text">Debes adjuntar el carnet AUF ID en un formato .png o .jpg, y en un tamaño no mayor a 2MB.</span>
								</div>
							</div>
							<div class="medio-form-row">
								<div class="input-group">
									<label for="integrante-rol">Rol</label>
									<input type="text" name="integrante-rol" id="integrante-rol" v-model="integrante.rol">
								</div>
								<div class="input-group">
									<button class="btn-eliminar-integrante" @click="eliminarIntegrante(index)">Eliminar integrante<trash-icon></trash-icon></button>
								</div>
							</div>
						</div>
						<button class="btn-agregar-integrante" @click="agregarIntegrante(medioIntegrantes.length)">
							Agregar integrante<user-plus-icon></user-plus-icon>
						</button>
						<div class="registrar-medio-button">
							<button class="btn" @click="registrarMedio">Registrar medio</button>
						</div>
					</div>
				</div>
				<div class="registro-medio-right">
					<div class="registro-medio-right-content">
						<div class="descripcion">
							<span class="descripcion-title">Información importante</span>
							<div class="espectaculo-descripcion">
								Independientemente del cumplimiento de los requisitos exigidos para la asignación de las acreditaciones solicitadas, la misma queda sujeta a aprobación del Departamento de Comunicaciones. El cumplimiento de la totalidad de los mismos no garantiza la confirmación ni aprobación alguna, solamente habilita a efectuar la solicitud, siendo que el Club posee la facultad y el derecho de admitir o no el otorgamiento de las acreditaciones a los solicitantes.<br><br>Estas son las condiciones establecidas en el Protocolo de acreditaciones: <a href="https://nacional.uy/es/news/es-protocolo-de-acreditaciones-para-los-medios-de-comunicacion-2022-08-19" target="_blank">ver.</a><br><br>En caso de querer agregar un integrante del medio, comunicarse a <a href="mailto:acreditaciones@nacional.uy">acreditaciones@nacional.uy</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal class="promptRegistroPrensaExitoso" name="promptRegistroPrensaExitoso" :clickToClose="false">
			<div class="registro-exitoso-content">
				<div class="registro-exitoso-header">
					<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
						<circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
						<path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
					</svg>
				</div>
				<div class="registro-exitoso-main">
					<span class="title">Solicitud de registro enviada</span>
				</div>
				<div class="registro-exitoso-footer">
					<span>La solicitud de registro de medio de prensa fue enviada correctamente. Recibirás un email notificando si la misma fue aceptada o no.</span>
				</div>
				<div class="registro-exitoso-boton">
					<a href="https://nacional.uy" class="btn">Volver</a>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import { TrashIcon, UserPlusIcon } from 'vue-feather-icons'

	export default{
		name: 'registro-medio',
		data(){
			return {
				hayError: false,
				errorMsg: '',
				medio: {
					nombre: '',
					tipo: null,
					sitioWeb: '',
					instagram: '@',
					twitter: '@'
				},
				medioTipos: [],
				medioResponsable: {
					nombre: '',
					apellido: '',
					tipoDocumento: null,
					documento: '',
					email: '',
					telefono: '',
					aufIdB64: ''
				},
				tipoDocumentoCI: null,
				tipoDocumentos: [],
				medioIntegrantes: []
			}
		},
		components: {
			TrashIcon,
			UserPlusIcon
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.tiposDocumento();
			await this.agregarIntegrante(0);
			await this.tiposMedios();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			onFileChange(e) {
				var files = e.target.files || e.dataTransfer.files;
				if (!files.length){
					this.$refs.responsableaufid.value = null
					this.medioResponsable.aufIdB64 = '';
					return;
				}

				if(files[0].size > (1024 * 1024 * 2)){ // Si supera los 2 MB
					this.$refs.responsableaufid.value = null
					this.medioResponsable.aufIdB64 = '';

					alert('Imagen supera el peso máximo.')
					return;
				}

				this.createImage(files[0]);
			},
			onFileChangeIntegrante(e, index) {
				var files = e.target.files || e.dataTransfer.files;
				if (!files.length){
					this.$refs['integranteaufid' + index].value = null
					this.medioIntegrantes[index].aufIdB64 = '';
					return;
				}

				if(files[0].size > (1024 * 1024 * 2)){ // Si supera los 2 MB
					this.$refs['integranteaufid' + index].value = null
					this.medioIntegrantes[index].aufIdB64 = '';

					alert('Imagen supera el peso máximo.')
					return;
				}

				this.createImageIntegrante(files[0], index);
			},
			createImage(file) {
				var reader = new FileReader();

				reader.readAsDataURL(file);
				reader.onload = () => {
					let b64 = reader.result.split(';base64,');
					this.medioResponsable.aufIdB64 = b64[1];
				}
			},
			createImageIntegrante(file, index) {
				var reader = new FileReader();

				reader.readAsDataURL(file);
				reader.onload = () => {
					let b64 = reader.result.split(';base64,');
					this.medioIntegrantes[index].aufIdB64 = b64[1];
				}
			},
			async agregarIntegrante(i){
				let integrante = {
					id: 1 + i,
					nombre: '',
					apellido: '',
					tipoDocumento: this.tipoDocumentoCI,
					documento: '',
					rol: '',
					aufIdB64: ''
				}

				this.medioIntegrantes.push(integrante);
			},
			async eliminarIntegrante(i){
				if(this.medioIntegrantes.length > 1){
					this.medioIntegrantes.splice(i, 1);
				} else {
					this.medioIntegrantes.splice(i, 1);
					await this.agregarIntegrante(0);
				}
			},
			async tiposDocumento(){
				// Obtengo tipos de documento
				try{
					let response = await axios.post('/WSDocumentoTipoCortesiaPalco', {});
					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
							this.medioResponsable.tipoDocumento = this.tipoDocumentoCI
						}
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async tiposMedios(){
				// Obtengo tipos de medios
				try{
					let response = await axios.post('/WSPrensaTipo', {});
					for(var o=0; o<response.data.SDTPrensaTipo.length; o++){
						this.medioTipos.push({ valor: parseInt(response.data.SDTPrensaTipo[o].PrensaTipoId), descripcion: response.data.SDTPrensaTipo[o].PrensaTipoNombre });
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async registrarMedio(){
				this.$store.dispatch('cargando', true);
				await this.validacionDatos();

				if(this.hayError === false){
					try {
						let SDTPrensaMedio = {
							PrensaMedioNombre: this.medio.nombre,
							PrensaTipoId: parseInt(this.medio.tipo.valor),
							PrensaMedioSitioWeb: this.medio.sitioWeb,
							PrensaMedioTwitter: this.medio.twitter,
							PrensaMedioInstagram: this.medio.instagram
						}

						let SDTPrensaResponsable = {
							PrensaMedioResponsableNombre: this.medioResponsable.nombre,
							PrensaMedioResponsableApellido: this.medioResponsable.apellido,
							DocumentoTipoId: parseInt(this.medioResponsable.tipoDocumento.valor),
							PrensaMedioResponsableDocumento: this.medioResponsable.documento,
							PrensaMedioResponsableEmail: this.medioResponsable.email,
							PrensaMedioResponsableTelefono: this.medioResponsable.telefono,
							PrensaMedioResponsableAUF: null,
							PrensaMedioResponsableAUFB64: this.medioResponsable.aufIdB64
						}

						let SDTPrensaIntegrante = [];

						for(let j=0; j<this.medioIntegrantes.length; j++){
							let integrante = {
								PrensaMedioIntegranteNombre: this.medioIntegrantes[j].nombre,
								PrensaMedioIntegranteApellido: this.medioIntegrantes[j].apellido,
								DocumentoTipoId: parseInt(this.medioIntegrantes[j].tipoDocumento.valor),
								PrensaMedioIntegranteDocumento: this.medioIntegrantes[j].documento,
								PrensaMedioIntegranteRol: this.medioIntegrantes[j].rol,
								PrensaMedioIntegranteAUFB64: this.medioIntegrantes[j].aufIdB64
							}

							SDTPrensaIntegrante.push(integrante);
						}

						let response = await axios.post('/WSPrensaMedioAlta', { SDTPrensaMedio: SDTPrensaMedio, SDTPrensaResponsable: SDTPrensaResponsable, SDTPrensaIntegrante: SDTPrensaIntegrante });

						if(response.data.ErrorCod === 0){
							this.$modal.show('promptRegistroPrensaExitoso');
						} else {
							this.$store.dispatch('mostrarError', response.data.ErrorDsc)
						}
					} catch (error) {
						this.$router.push({ name: 'error' });
					}
				} else {
					this.$store.dispatch('mostrarError', this.errorMsg)
				}

				this.$store.dispatch('cargando', false);
			},
			async validacionDatos(){
				this.hayError = false

				// Validación del medio
				if(!this.medio.nombre.trim()){
					this.hayError = true
					this.errorMsg = 'Debes ingresar el nombre del medio'
				}

				if(!this.medio.tipo && this.hayError === false){
					this.hayError = true
					this.errorMsg = 'Debes ingresar el tipo del medio'
				}

				// Validación del responsable
				if(this.hayError === false && !this.medioResponsable.nombre.trim()){
					this.hayError = true
					this.errorMsg = 'Debes ingresar el nombre del responsable del medio'
				}

				if(this.hayError === false && !this.medioResponsable.apellido.trim()){
					this.hayError = true
					this.errorMsg = 'Debes ingresar el apellido del responsable del medio'
				}

				if(this.hayError === false && !this.medioResponsable.documento.trim()){
					this.hayError = true
					this.errorMsg = 'Debes ingresar el documento del responsable del medio'
				}

				if(this.hayError === false && !this.medioResponsable.telefono.trim()){
					this.hayError = true
					this.errorMsg = 'Debes indicar el teléfono del responsable del medio'
				}

				if(this.hayError === false && !this.medioResponsable.email.trim()){
					this.hayError = true
					this.errorMsg = 'Debes indicar el correo electrónico del responsable del medio'
				}

				if(this.hayError === false && (this.medioResponsable.telefono.trim().length < 8 || this.medioResponsable.telefono.trim().length > 20)){
					this.hayError = true
					this.errorMsg = 'Teléfono del responsable del medio incorrecto'
				}

				if(this.hayError === false && !this.medioResponsable.aufIdB64.trim()){
					this.hayError = true
					this.errorMsg = 'Debes adjuntar el carnet AUF ID'
				}

				// Validación de los integrantes
				if(this.hayError === false){
					for(let i=0; i<this.medioIntegrantes.length; i++){
						if(this.hayError === false && !this.medioIntegrantes[i].nombre.trim()){
							this.hayError = true
							this.errorMsg = 'Debes ingresar el nombre del integrante #' + (i+1)
							break;
						}

						if(this.hayError === false && !this.medioIntegrantes[i].apellido.trim()){
							this.hayError = true
							this.errorMsg = 'Debes ingresar el apellido del integrante #' + (i+1)
							break;
						}

						if(this.hayError === false && !this.medioIntegrantes[i].documento.trim()){
							this.hayError = true
							this.errorMsg = 'Debes ingresar el documento del integrante #' + (i+1)
							break;
						}

						if(this.hayError === false && !this.medioIntegrantes[i].rol.trim()){
							this.hayError = true
							this.errorMsg = 'Debes ingresar el rol del integrante #' + (i+1)
							break;
						}

						if(this.hayError === false && !this.medioIntegrantes[i].aufIdB64.trim()){
							this.hayError = true
							this.errorMsg = 'Debes adjuntar el carnet AUF ID del integrante #' + (i+1)
							break;
						}

						if(this.hayError === false && (this.medioIntegrantes[i].documento.trim() === this.medioResponsable.documento.trim()) && (this.medioIntegrantes[i].tipoDocumento === this.medioResponsable.tipoDocumento)){
							this.hayError = true
							this.errorMsg = 'Error: no debes ingresar al responsable como integrante'
							break;
						}
					}
				}

			}
		}
	}
</script>

<style lang="scss" scoped>
	.registro-medio{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.registro-medio-main{
			width: 100%;
			position: relative;
			margin: 72px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.registro-medio-right{
					top: 102px;
					position: sticky;
					margin-top: 40px;
					width: calc(33.33% - 16px);

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
						margin-bottom: 18px;
					}

					.registro-medio-right-content{
						border-radius: 8px;
						border: 1px solid #d3d3dc;
						@include flex(column, flex-start, flex-start);

						.descripcion{
							border-radius: 0px;
							border: none;
							padding: 20px;
							width: 100%;
							@include flex(column, flex-start, flex-start);
							
							.descripcion-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 8px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}
						}
					}
				}

				.registro-medio-left{
					width: calc(66.66% - 16px);
					background-color: var(--color-white);
					padding: 0px;
					margin-top: 40px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					h2{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 38px;
						line-height: 36px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					.registro-medio-content{
						width: 100%;
						margin-top: 20px;
						display: grid;
						grid-template-columns: repeat(1, 1fr);
						grid-row-gap: 25px;

						.medio-form, .medio-responsable-form, .medio-integrantes-form{
							border-radius: 0px;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 20px;
							padding-left: 70px;
							position: relative;
							background-color: var(--color-white);
							@include flex(column, flex-start, flex-start);
							transition: all .2s;

							&:after{
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: 100%;
								@include flex(row, center, center);
								color: var(--color-red);
								writing-mode:vertical-lr;
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								font-weight: 700;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
								border-right: 8px solid var(--color-blue);
								border-left: 8px solid var(--color-blue);
								background-color: var(--color-white);
							}

							.medio-form-row{
								width: 100%;
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
									padding: 0px 8px 12px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									label{
										font-size: 16px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 19px;
										font-family: var(--font-family-fira);
									}

									input{
										font-size: 16px;
										line-height: 25px;
										padding-top: 8px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 8px;
										padding-bottom: 10px;

										&:focus{
											border-color: var(--color-blue);
										}
									}

									.btn-eliminar-integrante{
										@include flex(row, center, center);
										text-transform: uppercase;
										font-family: var(--font-family-poppins);
										font-weight: var(--font-weight-bold);
										position: relative;
										cursor: pointer;
										background-color: var(--color-white);
										color: var(--color-red);
										-webkit-transition: background-color .2s ease;
										transition: background-color .2s ease;
										-webkit-letter-spacing: 1px;
										-moz-letter-spacing: 1px;
										-ms-letter-spacing: 1px;
										letter-spacing: 1px;
										padding: 6px 10px;
										font-size: 11px;
										line-height: 1em;
										-webkit-font-smoothing: antialiased;
										-moz-osx-font-smoothing: grayscale;
										outline-color: transparent;
										outline: none;
										box-shadow: none;
										border: 1px solid var(--color-red);
										margin: 0;
										border-radius: 99px;

										-webkit-touch-callout: none;
										-webkit-user-select: none;
										-khtml-user-select: none;
										-moz-user-select: none;
										-ms-user-select: none;
										user-select: none;

										&:hover{
											background-color: var(--color-red);
											color: var(--color-white);

											svg{
												color: var(--color-white);
											}
										}

										svg{
											margin-left: 5px;
											width: 14px;
											height: auto;
											color: var(--color-red);
											margin-top: -2px;
											stroke-width: 2.5px;
										}
									}

									.small-text{
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-grey);
										font-family: var(--font-family-fira);
										font-size: 11px;
										line-height: 1.4em;
										padding: 0px 10px;
									}
								}
							}

							span.title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 10px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;

								.title-subtitle{
									font-size: 12px;
									color: var(--color-grey);
									margin-left: 5px;
									font-weight: var(--font-weight-regular);
								}
							}
						}

						.medio-form{
							&:after{
								content: 'DATOS DEL MEDIO';
							}
						}

						.medio-responsable-form{
							&:after{
								content: 'RESPONSABLE';
							}
						}

						.medio-integrantes-form{
							&:after{
								content: 'INTEGRANTES';
							}
						}

						.btn-agregar-integrante{
							// width: 240px;
							@include flex(row, space-between, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							background-color: var(--color-white);
							color: var(--color-blue);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 1px;
							-moz-letter-spacing: 1px;
							-ms-letter-spacing: 1px;
							letter-spacing: 1px;
							padding: 12px 14px;
							font-size: 13px;
							line-height: 1.2em;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 1px solid var(--color-blue);
							margin: 0;
							border-radius: 0px;

							-webkit-touch-callout: none;
							-webkit-user-select: none;
							-khtml-user-select: none;
							-moz-user-select: none;
							-ms-user-select: none;
							user-select: none;

							&:hover{
								background-color: var(--color-blue);
								color: var(--color-white);

								svg{
									color: var(--color-white);
								}
							}

							svg{
								margin-left: 5px;
								width: 16px;
								height: auto;
								color: var(--color-blue);
								margin-top: -1px;
								stroke-width: 2.5px;
							}
						}

						.registrar-medio-button{
							width: 100%;
							@include flex(row, center, center);
							
							button{
								width: 100%;
								@include flex(row, center, center);
								text-transform: uppercase;
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								position: relative;
								cursor: pointer;
								background-color: var(--color-blue);
								color: var(--color-white);
								-webkit-transition: background-color .2s ease;
								transition: background-color .2s ease;
								-webkit-letter-spacing: 1px;
								-moz-letter-spacing: 1px;
								-ms-letter-spacing: 1px;
								letter-spacing: 1px;
								padding: 12px 14px;
								font-size: 13px;
								line-height: 20px;
								-webkit-font-smoothing: antialiased;
								-moz-osx-font-smoothing: grayscale;
								outline-color: transparent;
								outline: none;
								box-shadow: none;
								border: 0;
								margin: 0;

								-webkit-touch-callout: none;
								-webkit-user-select: none;
								-khtml-user-select: none;
								-moz-user-select: none;
								-ms-user-select: none;
								user-select: none;

								&:hover{
									background-color: var(--color-blue-dark);
								}

								&:disabled{
									color: var(--color-dark);
									background-color: var(--color-grey-light);
									cursor: not-allowed;
								}
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and(max-width: 910px){
		.registro-medio{
			.registro-medio-main{
				margin: 30px 0;

				.container{
					@include flex(column, flex-start, flex-start);

					.registro-medio-left{
						width: 100%;
					}

					.registro-medio-right{
						margin-top: 30px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 590px){
		.registro-medio{
			.registro-medio-main{
				.container{
					.registro-medio-left{
						h1{
							font-size: 34px;
							line-height: 32px;
						}

						p{
							font-size: 15px;
							line-height: 14px;
							margin-top: 2px;
						}

						h2{
							font-size: 30px;
							line-height: 34px;
						}

						.registro-medio-content{
							.medio-form, .medio-responsable-form, .medio-integrantes-form{
								padding-left: 50px;

								.medio-form-row{
									.input-group{
										label{
											font-size: 14px;
											line-height: 17px;
										}

										input{
											font-size: 14px;
											line-height: 20px;
										}
									}
								}

								&:after{
									width: 30px;
									border-right: 6px solid var(--color-blue);
									border-left: 6px solid var(--color-blue);
									font-size: 12px;
								}
							}

							.btn-agregar-integrante{
								font-size: 12px;
								padding: 11px 14px;
							}

							.registrar-medio-button{
								button{
									padding: 11px 14px;
									font-size: 12px;
									line-height: 18px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 540px){
		.registro-medio{
			.registro-medio-main{
				.container{
					.registro-medio-left{
						.registro-medio-content{
							.medio-form, .medio-responsable-form, .medio-integrantes-form{
								.medio-form-row{
									@include flex(column, flex-start, flex-start);

									.input-group{
										width: 100%;
										padding: 0px;
										padding-bottom: 5px;

										.small-text{
											width: 100%;
											padding: 0px;
										}

										.btn-eliminar-integrante{
											margin-top: 5px;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>